import {FullScreenViewer } from 'iv-viewer';
import 'iv-viewer/dist/iv-viewer.css';

const zoomOpenerSelectors = [".slide-zoomable img",/* ".single-press main img"*/].join(',');
const optionFsv ={
  zoomValue:100
}

const onClick = e => {
  const imgUrl = e.currentTarget.src;
  const viewer = new FullScreenViewer(optionFsv); // check options section for supported options
  console.log(imgUrl);
  viewer.show(imgUrl,imgUrl);
  viewer.zoom(200);
};

export const cleanZoom = () => {
  const openers = document.querySelectorAll(zoomOpenerSelectors);
  openers.forEach(o => {
    o.removeEventListener("click", onClick);
  });
};

export const initZoom = () => {
  const openers = document.querySelectorAll(zoomOpenerSelectors);
 
  openers.forEach(o => {
    o.addEventListener("click", onClick);
  });
};
